import { render, staticRenderFns } from "./tbwj.vue?vue&type=template&id=3101ec2f&scoped=true"
import script from "./tbwj.vue?vue&type=script&lang=js"
export * from "./tbwj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3101ec2f",
  null
  
)

export default component.exports